<template>
  <div>
    <v-card>
      <v-layout row justify-center align-center id="export">
        <v-flex xs12>
          <v-card>
            <v-toolbar :color="getPaymentColor(payment.payment_state)" dark>

              <v-toolbar-title v-if="!ally">{{ $t(`enrollments.payment.payment`) }} {{ $t(`enrollments.payment_status.${payment.payment_state}`) }}</v-toolbar-title>
              <v-toolbar-title v-if="ally">{{ ally.name=="ASOPAF"?$t('enrollments.pay') : $t('enrollments.donation') + " "}} {{ $t(`enrollments.payment_status.${payment.payment_state}`) }} </v-toolbar-title>

            </v-toolbar>

            <v-list
              subheader
              dense
            >
              <v-subheader>{{ $t(`enrollments.payment.payment_detail`) }} {{ payment_detail }}</v-subheader>

              <div v-if="payment_image" class="px-3 text-xs-center">
                <img
                  :src="payment_image"
                  width="150px"
                  class="ml-auto mr-auto"
                >
              </div>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(`enrollments.payment.payment_type`) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ $t(`payments.types.${payment.payment_type}`) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(`enrollments.payment.reference`) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ payment.payment_id }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="payment.traceability_code">
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(`enrollments.payment.traceability_code`) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ payment.traceability_code }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(`enrollments.payment.date`) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ payment.updated_at }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="payment_quantity">
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t(`enrollments.payment.quantity`) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ payment_quantity }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Total</v-list-tile-title>
                  <v-list-tile-sub-title>{{payment.payment_currency}} {{ formatNumber(payment.service_payment_total) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <div v-if="payment_token" class="px-3 text-xs-center">
                  Código QR<br>
                  <vue-qrcode :value="`${appUrl}/verify-qr/${payment_token}`" :options="options" tag="img"></vue-qrcode>
              </div>

            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      <div v-if="payment_format" class="px-3 text-xs-center">
        <v-btn color="info" v-if="payment_format == 1" @click="exportToPDF">Exportar a PDF</v-btn>
        <v-btn color="info" v-else @click="exportToPNG">Exportar a PNG</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import VueQrcode from '@chenfengyuan/vue-qrcode'
  import html2pdf from "html2pdf.js";
  import html2canvas from "html2canvas";

  export default {
    components: { VueQrcode },
    name: 'payment-proof',
    props: {
      payment: {
        type: Object,
        required: true
      },
      ally: {
        type: Object,
        // required: true
      },
      payment_detail: {
        type: String,
        required: true
      },
      payment_quantity: {
        type: Number,
        required: false
      },
      payment_token: {
        type: String,
        required: false
      },
      payment_format: {
        type: String,
        required: false
      },
      payment_image: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        appUrl: window.config.appUrl,
        options: {
            maskPattern: 7,
            width: 250,
            color: {
                dark: '#000000',
                light: '#ffffff',
            },
            margin: 1
        }
      }
    },
    methods: {
      getPaymentColor(payment_state) {
        console.log("state",payment_state)
        if (payment_state === 'FAILED' ||
                payment_state === 'NOT_AUTHORIZED' ||
                payment_state === 'REJECTED' ||
                payment_state === 'DECLINED' ||
                payment_state === 'VOIDED' ||
                payment_state === 'ERROR' ||
                payment_state == '0') return 'error'

        if (payment_state === 'OK' ||
        payment_state === 'APPROVED') return 'success'

        if (payment_state === 'PENDING' ||
        payment_state === 'iniciado') return 'info'
      },
      formatNumber(number) {
        if(typeof number === 'undefined' || !number) {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      exportToPDF() {
        html2pdf(document.getElementById("export"), {
          margin: 1,
          filename: 'comprobante.pdf',
        });
      },
      async exportToPNG() {
        const options = {
          type: "dataURL",
        };
        const printCanvas = await html2canvas(document.getElementById("export"), options);

        const link = document.createElement("a");
        link.setAttribute("download", "comprobante.png");
        link.setAttribute(
          "href",
          printCanvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream")
        );
        link.click();

        console.log("done");
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/payment/proof.vue